import Pauschalenart from './pauschalenart';

const pauschalenartConverter = {
    toFirestore: (pauschalenart) => {
        return pauschalenart.getFirestore();
    },
    fromFirestore: (snapshot) => {
        const data = snapshot.data();
        return new Pauschalenart(
            snapshot.id,
            data.name,
            data.icon,
            data.datum,
            data.uhrzeit
        );
    }
};

export default pauschalenartConverter;